import React from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import {
  IPayloadProps,
  PayloadSubjectUtils,
} from "../../../../../components/multistep/IPayloadProps";

const PersonalInformation = (props: IPayloadProps) => {
  const subjects = new PayloadSubjectUtils();
  if (props.payload != null) {
    const preferredClaims =
      props.payload.claims['org.iso.23220.2'] ??
      props.payload.claims['org.iso.23220.1'];

    return (
    <Container
        fluid
        style={{
          minHeight: "150px",
          textAlign: "left",
          display: "inline-block",
          width: "auto",
        }}
      >
        <Row style={{ paddingTop: "70px" }}>
            <Col>
              <h2>Personal Information</h2>
            </Col>
          </Row>
        <Container>
          <span className="span-2">Name</span>
          <span className="span-6" style={{ marginLeft: "20px" }}>
            {preferredClaims ? preferredClaims.given_name + " " + preferredClaims.family_name : props.payload?.claims.given_name + " " + props.payload?.claims.family_name}&nbsp;
            <img
              src="https://freesvg.org/img/kuba-icon-ok.png"
              style={{
                width: "20px",
                display: preferredClaims?.given_name || preferredClaims?.family_name || props.payload?.claims.given_name || props.payload?.claims.family_name
                  ? "inline"
                  : "none",
              }}
            ></img>
          </span>
        </Container>
        {/* <Container>
          <span className="span-2">National ID</span>
          <span className="span-6" style={{ marginLeft: "20px" }}>
            {" "}
            {subjects.getSubjects(props.payload)?.documentNumber}&nbsp;
            <img
              src="https://freesvg.org/img/kuba-icon-ok.png"
              style={{
                width: "20px",
                display: subjects.getSubjects(props.payload)?.documentNumber
                  ? "inline"
                  : "none",
              }}
            ></img>
          </span>
        </Container> */}
        <Container>
          <span className="span-2">Birthdate</span>
          <span className="span-6" style={{ marginLeft: "20px" }}>
            {" "}
            {preferredClaims ? preferredClaims.birth_date : props.payload?.claims.birthdate}&nbsp;
            <img
              src="https://freesvg.org/img/kuba-icon-ok.png"
              style={{
                width: "20px",
                display: preferredClaims?.birth_date || props.payload?.claims.birthdate
                  ? "inline"
                  : "none",
              }}
            ></img>
          </span>
          </Container>
        <Container>
          <span className="span-2">Issue Date</span>
          <span className="span-6" style={{ marginLeft: "20px" }}>
            {" "}
            {preferredClaims ? new Date(preferredClaims.issue_date).toISOString().split('T')[0] : new Date(props.payload?.claims.iat).toISOString().split('T')[0]}&nbsp;
            <img
              src="https://freesvg.org/img/kuba-icon-ok.png"
              style={{
                width: "20px",
                display: preferredClaims?.issue_date ||  props.payload?.claims.iat
                  ? "inline"
                  : "none",
              }}
            ></img>
          </span>
        </Container>
        <Container>
          <span className="span-2">Expiry Date</span>
          <span className="span-6" style={{ marginLeft: "20px" }}>
            {" "}
            {preferredClaims ? new Date(preferredClaims.expiry_date).toISOString().split('T')[0] : new Date(props.payload?.claims.exp).toISOString().split('T')[0]}&nbsp;
            <img
              src="https://freesvg.org/img/kuba-icon-ok.png"
              style={{
                width: "20px",
                display: preferredClaims?.expiry_date || props.payload?.claims.exp
                  ? "inline"
                  : "none",
              }}
            ></img>
          </span>
        </Container>
        <Container>
          <span className="span-2">Issuing Country</span>
          <span className="span-6" style={{ marginLeft: "20px" }}>
            {" "}
            {preferredClaims ? preferredClaims.issuing_country : props.payload?.claims.issuing_country}&nbsp;
            <img
              src="https://freesvg.org/img/kuba-icon-ok.png"
              style={{
                width: "20px",
                display: preferredClaims?.issuing_country || props.payload?.claims.issuing_country
                  ? "inline"
                  : "none",
              }}
            ></img>
          </span>
        </Container>
        <Container>
          <span className="span-2">Issuing Authority</span>
          <span className="span-6" style={{ marginLeft: "20px" }}>
            {" "}
            {preferredClaims ? preferredClaims.issuing_authority : props.payload?.claims.issuing_authority}&nbsp;
            <img
              src="https://freesvg.org/img/kuba-icon-ok.png"
              style={{
                width: "20px",
                display: preferredClaims?.issuing_authority || props.payload?.claims.issuing_authority
                  ? "inline"
                  : "none",
              }}
            ></img>
          </span>
        </Container>
        {/* <Container>
          <span className="span-2">Place of Birth</span>
          <span className="span-6" style={{ marginLeft: "20px" }}>
            {subjects.getSubjects(props.payload)?.placeOfBirth}&nbsp;
            <img
              src="https://freesvg.org/img/kuba-icon-ok.png"
              style={{
                width: "20px",
                display: subjects.getSubjects(props.payload)?.placeOfBirth
                  ? "inline"
                  : "none",
              }}
            ></img>
          </span>
        </Container> */}
      </Container>
    );
  }
  else {
    return (
      <Container
        fluid
        className="d-flex justify-content-center align-items-center"
      >
        <Form
          style={{
            width: "800px",
            padding: "40px",
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        >
          <Row>
            <Col>
              <Button
                onClick={() =>
                  props.authenticateUser ? props.authenticateUser() : null
                }
                type="button"
              >
                Use your Digital ID
              </Button>
            </Col>
          </Row>
          <Row style={{ paddingTop: "50px" }}>
            <h6>OR</h6>
          </Row>
  
          <Row style={{ paddingTop: "70px" }}>
            <Col>
              <h2>Personal Information</h2>
            </Col>
          </Row>
          <Form.Group as={Row} controlId="formFirstName" className="py-3">
            <Form.Label column sm={12} style={{ textAlign: "left" }}>
              Full Name
            </Form.Label>
            <Col sm={12}>
              <Form.Control type="text" name="name" />
            </Col>
          </Form.Group>
  
          <Form.Group as={Row} controlId="formEmail" className="py-3">
            <Form.Label column sm={12} style={{ textAlign: "left" }}>
              Email
            </Form.Label>
            <Col sm={12}>
              <Form.Control type="email" name="email" />
            </Col>
          </Form.Group>
  
          <Form.Group as={Row} controlId="formContactNumber" className="py-3">
            <Form.Label column sm={12} style={{ textAlign: "left" }}>
              Phone Number
            </Form.Label>
            <Col sm={12}>
              <Form.Control type="tel" name="phoneNumber" />
            </Col>
          </Form.Group>
  
          <Form.Group as={Row} controlId="formDateOfBirth" className="py-3">
            <Form.Label column sm={12} style={{ textAlign: "left" }}>
              Date of Birth
            </Form.Label>
            <Col sm={12}>
              <Form.Control type="date" name="birthdate" />
            </Col>
          </Form.Group>
  
          <Row style={{ paddingTop: "30px" }}>
            <Col>
              <h2>Delivery Details</h2>
            </Col>
          </Row>
  
          <Form.Group as={Row} controlId="formAddress" className="py-3">
            <Form.Label column sm={12} style={{ textAlign: "left" }}>
              Address
            </Form.Label>
            <Col sm={12}>
              <Form.Control type="text" name="streetAddress1" />
            </Col>
          </Form.Group>
  
          <Form.Group as={Row} controlId="formCity" className="py-3">
            <Form.Label column sm={12} style={{ textAlign: "left" }}>
              City
            </Form.Label>
            <Col sm={12}>
              <Form.Control type="text" name="city" />
            </Col>
          </Form.Group>
  
          <Form.Group as={Row} controlId="formState" className="py-3">
            <Form.Label column sm={12} style={{ textAlign: "left" }}>
              State
            </Form.Label>
            <Col sm={12}>
              <Form.Control type="text" name="county" />
            </Col>
          </Form.Group>
  
          <Form.Group as={Row} controlId="formZipCode" className="py-3">
            <Form.Label column sm={12} style={{ textAlign: "left" }}>
              Zip Code
            </Form.Label>
            <Col sm={12}>
              <Form.Control type="text" name="postalCode" />
            </Col>
          </Form.Group>
  
          <Form.Group as={Row} controlId="formCountry" className="py-3">
            <Form.Label column sm={12} style={{ textAlign: "left" }}>
              Country
            </Form.Label>
            <Col sm={12}>
              <Form.Control type="text" name="country" />
            </Col>
          </Form.Group>
        </Form>
      </Container>
    );
  }
  
};

export default PersonalInformation;
